import { EVENT_TYPES, EVENTS } from './editor.constants'
import { BUTTON_TYPES } from '@/store/constants'
import { GPT_VERSIONS } from './bot-json.constants'
import scrape_web_icon from '@/assets/images/icons/scrape_web_icon.svg'
import code_file_icon from '@/assets/images/icons/code_file_icon.svg'
import file_icon from '@/assets/images/icons/file_icon.svg'
import { KNOWLEDGE_BASES } from '@/utils/knowledgeBase.constants'

class DropdownButtonsUtils {
  getEventOptions(createdEvents) {
    const filteredEvents = EVENTS.filter(({ type }) => {
      if(type === EVENT_TYPES.CUSTOM_EVENT) return true

      return !createdEvents.some(({ type: createdEventType }) => type === createdEventType)
    })

    return filteredEvents.map(({ name, description, type }) => {
      return {
        title: name,
        description: description,
        type: type
      }
    })
  }

  getButtonTypeOptions() {
    return [{
      title: 'Action',
      icon: { tag: 'ActionIcon' },
      description: 'Creates a new path in the conversation flow.',
      value: BUTTON_TYPES.POSTBACK
    }, {
      title: 'Website',
      icon: { tag: 'vs-icon', identifier: 'link' },
      description: 'Opens the link in new tab.',
      value: BUTTON_TYPES.URL
    }, {
      title: 'Phone',
      icon: { tag: 'vs-icon', identifier: 'phone' },
      description: `Dials the phone number. <br/>
        <span class="text-xs">Tip: store the phone number in text for desktop users.</span>`,
      value: BUTTON_TYPES.PHONE
    }, {
      title: 'Callback',
      icon: { tag: 'JavascriptIcon' },
      description: `Executes a JavaScript callback that your website can react to <br/>
        <span class="text-xs">e.g. add an item to the shopping basket</span>`,
      value: BUTTON_TYPES.CALLBACK
    }]
  }

  getGptVersionOptions() {
    const options = [
      {
        title: 'Chat GPT-4o mini',
        icon: { tag: 'vs-icon', identifier: 'star' },
        description: `
          - Fast lightweight model, quick responses, modest reasoning<br/>
          - Data is processed within the EU<br/>
          - 128K context length
          <div class="flex">
            <span class="w-32">Reasoning</span>
            <span>●●●○○</span>
          </div>
          <div class="flex">
            <span class="w-32">Speed</span>
            <span>●●●●●</span>
          </div>
          <div class="flex">
            <span class="w-32">Accuracy</span>
            <span>●●●○○</span>
          </div>
        `,
        value: GPT_VERSIONS.FOUR_OMNI_MINI
      },
      {
        title: 'Chat GPT-4o',
        icon: { tag: 'vs-icon', identifier: 'lightbulb' },
        description: `
          - Advanced multimodal intelligence<br/>
          - Data is processed within the EU<br/>
          - 128K context length
          <div class="flex">
            <span class="w-32">Reasoning</span>
            <span>●●●●○</span>
          </div>
          <div class="flex">
            <span class="w-32">Speed</span>
            <span>●●●○○</span>
          </div>
          <div class="flex">
            <span class="w-32">Accuracy</span>
            <span>●●●●○</span>
          </div>
        `,
        value: GPT_VERSIONS.FOUR_OMNI_EU
      },
      {
        title: 'Chat GPT-4.1 nano',
        icon: { tag: 'vs-icon', identifier: 'bolt' },
        description: `
          - Smallest and fastest option, weak reasoning<br/>
          - Not recommended for product recommendations<br/>
          - Data is processed within the EU<br/>
          - 1M context length
          <div class="flex">
            <span class="w-32">Reasoning</span>
            <span>●●○○○</span>
          </div>
          <div class="flex">
            <span class="w-32">Speed</span>
            <span>●●●●●</span>
          </div>
          <div class="flex">
            <span class="w-32">Accuracy</span>
            <span>●●●○○</span>
          </div>
        `,
        value: GPT_VERSIONS.FOUR_POINT_ONE_NANO
      },
      {
        title: 'Chat GPT-4.1 mini',
        icon: { tag: 'vs-icon', identifier: 'star' },
        description: `
          - Balanced small model with solid accuracy and reasoning<br/>
          - Data is processed within the EU<br/>
          - 1M context length
          <div class="flex">
            <span class="w-32">Reasoning</span>
            <span>●●●●○</span>
          </div>
          <div class="flex">
            <span class="w-32">Speed</span>
            <span>●●●●○</span>
          </div>
          <div class="flex">
            <span class="w-32">Accuracy</span>
            <span>●●●●○</span>
          </div>
        `,
        value: GPT_VERSIONS.FOUR_POINT_ONE_MINI
      },
      {
        title: 'Chat GPT-5 nano',
        icon: { tag: 'vs-icon', identifier: 'bolt' },
        description: `
          - Fast model with improved accuracy<br/>
          - Data is processed within the EU<br/>
          - 2M context length
          <div class="flex">
            <span class="w-32">Reasoning</span>
            <span>●●●○○</span>
          </div>
          <div class="flex">
            <span class="w-32">Speed</span>
            <span>●●●●●</span>
          </div>
          <div class="flex">
            <span class="w-32">Accuracy</span>
            <span>●●●●○</span>
          </div>
        `,
        value: GPT_VERSIONS.FIVE_NANO
      },
      {
        title: 'Chat GPT-5 mini',
        icon: { tag: 'vs-icon', identifier: 'star' },
        description: `
          - High accuracy and reasoning<br/>
          - Data is processed within the EU<br/>
          - 2M context length
          <div class="flex">
            <span class="w-32">Reasoning</span>
            <span>●●●●●</span>
          </div>
          <div class="flex">
            <span class="w-32">Speed</span>
            <span>●●●●○</span>
          </div>
          <div class="flex">
            <span class="w-32">Accuracy</span>
            <span>●●●●●</span>
          </div>
        `,
        value: GPT_VERSIONS.FIVE_MINI
      },
      {
        title: 'Chat GPT-5.4 nano',
        icon: { tag: 'vs-icon', identifier: 'bolt' },
        description: `
          - Fastest GPT-5.4 option for simple high-volume tasks<br/>
          - Ideal for classification, extraction, and ranking<br/>
          - 400K context length
          <div class="flex">
            <span class="w-32">Reasoning</span>
            <span>●●●○○</span>
          </div>
          <div class="flex">
            <span class="w-32">Speed</span>
            <span>●●●●●</span>
          </div>
          <div class="flex">
            <span class="w-32">Accuracy</span>
            <span>●●●●○</span>
          </div>
        `,
        value: GPT_VERSIONS.FIVE_POINT_FOUR_NANO
      },
      {
        title: 'Chat GPT-5.4 mini',
        icon: { tag: 'vs-icon', identifier: 'star' },
        description: `
          - Stronger GPT-5.4 option with better reasoning and accuracy<br/>
          - Balanced speed and capability for more demanding tasks<br/>
          - 400K context length
          <div class="flex">
            <span class="w-32">Reasoning</span>
            <span>●●●●○</span>
          </div>
          <div class="flex">
            <span class="w-32">Speed</span>
            <span>●●●●○</span>
          </div>
          <div class="flex">
            <span class="w-32">Accuracy</span>
            <span>●●●●●</span>
          </div>
        `,
        value: GPT_VERSIONS.FIVE_POINT_FOUR_MINI
      },
      {
        title: 'Chat GPT-5.5',
        icon: { tag: 'vs-icon', identifier: 'lightbulb' },
        description: `
          - Most capable GPT-5 option for complex reasoning<br/>
          - Data is processed within the EU<br/>
          - 2M context length
          <div class="flex">
            <span class="w-32">Reasoning</span>
            <span>●●●●●</span>
          </div>
          <div class="flex">
            <span class="w-32">Speed</span>
            <span>●●○○○</span>
          </div>
          <div class="flex">
            <span class="w-32">Accuracy</span>
            <span>●●●●●</span>
          </div>
        `,
        value: GPT_VERSIONS.FIVE_POINT_FIVE
      }
    ]

    return options
  }

  getScrapedFileTypeOptions() {
    return [
      {
        title: 'TXT File',
        description: `
          - Formatting via Amio algorithm<br/>
          - Suitable for most use cases<br/>
          - Retains all of the original content<br/>
        `,
        value: 'txt'
      },
      {
        title: 'Markdown File',
        description: `
          - Formatting via GPT<br/>
          - Suitable for complex use cases<br/>
          - ⚠️ GPT might modify the content
        `,
        value: 'md'
      }
    ]
  }

  getAddKBSourceOptions() {
    return [
      {
        label: '<div class="ml-4 w-32 text-black font-medium">XML Feed</div>',
        title: 'XML Feed',
        icon: { identifier: code_file_icon, tag: 'img' },
        key: KNOWLEDGE_BASES.XML_FEED
      },
      {
        label: '<div class="ml-4 w-32 text-black font-medium">File</div>',
        title: 'File',
        icon: { identifier: file_icon, tag: 'img' },
        key: KNOWLEDGE_BASES.FILE
      },
      {
        label: '<div class="ml-4 w-32 text-black font-medium">Web Page (BETA)</div>',
        title: 'Web Page',
        icon: { identifier: scrape_web_icon, tag: 'img' },
        key: KNOWLEDGE_BASES.WEB_PAGE
      }
    ]
  }
}

export default new DropdownButtonsUtils()
